/******************************************************************
 * Archivo : client/src/mutations/createUser.js
 * Proyecto: CB30
 * Módulo  : Usuarios
 * Proceso : Crear usuario
 ******************************************************************/

import gql from "graphql-tag";

export default gql`
  mutation CreateUser(
    $email: String!
    $nombre: String!
    $apellido: String!
    $active: Boolean!
    $validated: Boolean!
    $tipoPerfil: Int
    $roleId: ID!
    $password: String!
  ) {
    createUser(
      email: $email
      nombre: $nombre
      apellido: $apellido
      active: $active
      validated: $validated
      tipoPerfil: $tipoPerfil
      roleId: $roleId
      password: $password
    ) {
      id
      email
      nombre
      apellido
    }
  }
`;



// WEBPACK FOOTER //
// ./src/mutations/createUser.js